module.exports = __webpack_public_path__ + "img/service.5bc7383d.png";